// extracted by mini-css-extract-plugin
export default {"caption":"PhuHuynhChildList_caption__34alx","list_horizontal":"PhuHuynhChildList_list_horizontal__nARTN","list_horizontal_item":"PhuHuynhChildList_list_horizontal_item__aubTd"};